<div class="card-container" *ngIf="dayReport">
    <div class="card-date">{{dayReport['xml'].date | date: 'dd/MM/yyyy'}}</div>
    <div class="card-sections">
        <table class="section" *ngFor="let type of ['xml', 'rest']">
            <thead>
                <tr>
                    <th class="section-title" colspan="4">{{type | uppercase}}</th>
                </tr>
                <tr>
                    <th class="col-ok">OK</th>
                    <th class="col-ko">KO Tech</th>
                    <th class="col-ko">KO Dispo</th>
                    <th class="col-pct">%</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="cell-ok">{{dayReport[type].availabilityOK}}</td>
                    <td class="cell-ko">{{dayReport[type].availabilityKOTech}}</td>
                    <td class="cell-ko">{{dayReport[type].availabilityKOAvail}}</td>
                    <td class="cell-pct">{{dayReport[type].ratioAvailabilityKO}}</td>
                </tr>
                <tr>
                    <td class="cell-ok">{{dayReport[type].quotedOK}}</td>
                    <td class="cell-ko">{{dayReport[type].quotedKOTech}}</td>
                    <td class="cell-ko">{{dayReport[type].quotedKOAvail}}</td>
                    <td class="cell-pct">{{dayReport[type].ratioQuotedKO}}</td>
                </tr>
                <tr>
                    <td class="cell-ok">{{dayReport[type].bookedOK}}</td>
                    <td class="cell-ko">{{dayReport[type].bookedKOTech}}</td>
                    <td class="cell-ko">{{dayReport[type].bookedKOAvail}}</td>
                    <td class="cell-pct">{{dayReport[type].ratioBookedKO}}</td>
                </tr>
                <tr>
                    <td class="cell-ok">{{dayReport[type].cancelledOK}}</td>
                    <td class="cell-ko">{{dayReport[type].cancelledKOTech}}</td>
                    <td class="cell-ko">{{dayReport[type].cancelledKOAvail}}</td>
                    <td class="cell-pct">{{dayReport[type].ratioCancelledKO}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>